import { Link } from 'react-router-dom'
import { Icons } from '../icons'
import { useAuth } from '../../contexts/AuthContext'
import { roleStartPath } from '../../utils/constants'

/** 403-Ansicht: Session hat keine Berechtigung für die aktuelle Route.
 *  BMC-Designsystem `console.css` (`.panel` + `.empty`). */
export function Forbidden({
  title = 'Kein Zugriff',
  message = 'Du hast keine Berechtigung für diese Ansicht.',
}: {
  title?: string
  message?: string
}) {
  const { session } = useAuth()
  const homePath = session ? roleStartPath(session.role) : '/login'
  return (
    <section className="panel">
      <div className="empty">
        <div className="eicon">{Icons.lock}</div>
        <div className="etitle">{title}</div>
        <p>{message}</p>
        <Link to={homePath} className="btn outline" style={{ marginTop: '14px' }}>
          Zur Startseite
        </Link>
      </div>
    </section>
  )
}
